// @flow

import { hpfetch } from '../util';
import type {
  commerceItemType,
  commercePurchaseType,
  commerceInvoiceType,
} from '../../types';
import type { djangoModelApiResponse } from '../apiTypes';

export const getItemsByType = (
  itemType: string,
): Promise<djangoModelApiResponse<commerceItemType>> =>
  hpfetch(`commerce/items/?item_type=${itemType}&ordering=-price_base`);

export const purchase = (fields: commercePurchaseType) =>
  hpfetch('commerce/purchases/', {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const getPurchase = (
  transactionId: number,
): Promise<djangoModelApiResponse<commerceInvoiceType>> =>
  hpfetch(`commerce/purchases/${transactionId}/`);
